import MiDataTable, { MiDataTableOptions } from '@/components/MiDataTable/MiDataTable';
import { AxiosError } from 'axios';
import { Component, Vue } from 'vue-property-decorator';
import { Library as LibraryModel } from '@/models/Library';
import ErrorHandler from '@/support/ErrorHandler';
import { MiDialogOptions } from '@/components/MiDialog/MiDialog';
import DefaultDialog from '@/components/dialog/DefaultDialog.vue';
import LibraryUpload from '@/components/library-upload/LibraryUpload.vue';
import { clone } from 'lodash';

@Component<Library>({
  components: {
    'default-dialog': DefaultDialog,
    'library-upload': LibraryUpload,
  },
})
export default class Library extends Vue {
  protected $pageTitle = 'Bibliotheek';

  protected isLoading = false;

  protected selectedAttachment: LibraryModel| null = null;

  protected acceptedFileTypes: string[] = [];

  protected isCreatingAttachment = false;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  protected postTimeOut: any | null = null;

  protected uploadQueue: File[] = [];

  protected fileCounter = 0;

  protected isScopedSlot(name: string): boolean {
    return Object.keys(this.$scopedSlots).some((key: string) => key.includes(name));
  }

  protected close(): void {
    this.isCreatingAttachment = false;
    this.selectedAttachment = null;
  }

  public editAttachment(attachment: LibraryModel): void {
    this.selectedAttachment = clone(attachment);
    this.isCreatingAttachment = true;
  }

  public async viewAttachment(id: string): Promise<void> {
    const file = await new LibraryModel().getFile(id);
    window.open(file);
  }

  protected async handleFileUploaded(): Promise<void> {
    setTimeout(() => {
      this.close();
    }, 500);

    this.datatable.refresh();
  }

  protected updateFile(): void {
    if (! this.selectedAttachment) {
      return;
    }

    const payload: {[key: string]: string | boolean} = {
      file_name: this.selectedAttachment.file_name ? this.selectedAttachment.file_name : '',
      description: this.selectedAttachment.description ? this.selectedAttachment.description : '',
      hin_show_to_all: this.selectedAttachment.hin_show_to_all ? this.selectedAttachment.hin_show_to_all : '',
    };

    this.isLoading = true;

    new LibraryModel({ uuid: this.selectedAttachment.uuid })
      .update(payload)
      .then(async () => {
        this.datatable.refresh();
        this.close();
        this.isLoading = false;
      })
      .catch((error: AxiosError) => {
        ErrorHandler.network(error);
        this.isLoading = false;
      });
  }

  public deleteAttachment(attachment: LibraryModel): void {
    this.selectedAttachment = attachment;
    this.$store.dispatch('openDialog', this.dialogOptionsDelete);
  }

  protected get dialogOptionsDelete(): MiDialogOptions {
    return {
      title: 'Bevestigen',
      text: 'Weet je zeker dat je deze bijlage wilt verwijderen?',
      type: 'warning',
      buttons: {
        confirm: {
          color: 'error',
          text: 'Verwijderen',
          action: () => {
            this.handleDeleteAttachment();
          },
        },
        cancel: {
          text: 'Annuleren',
          color: 'text-light',
          action: () => {
            this.selectedAttachment = null;
          },
        },
      },
    };
  }

  protected async handleDeleteAttachment(): Promise<void> {
    if (! this.selectedAttachment) {
      return;
    }

    this.isLoading = true;
    new LibraryModel({ uuid: this.selectedAttachment.uuid })
      .delete()
      .then(async () => {
        this.datatable.refresh();
        this.close();
        this.isLoading = false;
      })
      .catch((error: AxiosError) => {
        ErrorHandler.network(error);
        this.isLoading = false;
      });
  }

  public addAttachment(): void {
    this.isCreatingAttachment = true;
    this.selectedAttachment = null;
  }

  /**
   * Datatable config
   */

  protected get tableOptions(): MiDataTableOptions {
    return {
      model: new LibraryModel(),
      headers: [
        {
          text: 'Bestand',
          value: 'file_name',
          class: 'w-1/5',
        },
        {
          text: 'Beschrijving',
          value: 'description',
          class: 'w-1/4',
          sortable: false,
        },
        ...this.$store.getters.isBureau ? [{
          text: 'Zichtbaar voor herstelbedrijf',
          value: 'hin_show_to_all',
          sortable: false,
        }] : [],
        {
          text: 'Geüpload door',
          value: 'uploaded_by',
        },
        {
          text: 'Aangemaakt op',
          value: 'created_at',
          class: 'pr-128',
        },
        {
          text: 'Acties',
          value: 'actions',
          class: 'actions text-right',
          sortable: false,
          align: 'end',
        },
      ],
    };
  }

  protected get datatable(): MiDataTable {
    return this.$refs.libraryTable as MiDataTable;
  }
}

// type Media = {
//   uuid?: string,
//   file?: string,
//   file_name?: string;
//   description?: string;
//   hin_show_to_all?: boolean;
//   uploaded_by?: string;
//   original?: string;
// }

// interface FileType {
//   label: string;
//   value: string;
// }

// export interface AttachmentHeader {
//   text: string;
//   value: string;
//   class?: string;
//   align?: 'start' | 'center' | 'end';
//   visible?: boolean;
//   sortable?: boolean;
// }
